import { render } from "./ContactData.vue?vue&type=template&id=c4d98164"
import script from "./ContactData.vue?vue&type=script&lang=js"
export * from "./ContactData.vue?vue&type=script&lang=js"
script.render = render

export default script